import React from 'react'

export default function LargeTextDecorator({ children }) {
  return <span style={{ fontSize: '1.5rem' }}>{children}</span>
}
